import React,{ useState,useRef,useEffect } from 'react'
const faqs = [
    {
        id: 1,
        question: "What services does PMC provide?",
        answer:
            `PMC offers project management consulting, strategic business insights, financial expertise, and management consultancy to drive sustainable growth.`,
    },
    {
        id: 2,
        question: "How can PMC help improve my business operations?",
        answer:
            `We analyze your current processes, identify areas for improvement, and provide tailored solutions to enhance efficiency, profitability, and long-term success.`,
    },
    {
        id: 3,
        question: "Does PMC offer customized consulting solutions?",
        answer:
            `Yes, our consulting services are tailored to meet the unique needs of each client, ensuring effective and results-driven solutions`,
    },
    {
        id: 4,
        question: "What industries does PMC specialize in?",
        answer:
            `We work across various industries, including construction, finance, real estate, and corporate sectors, providing expert management and financial consultancy.`,
    },
    {
        id: 5,
        question: "How can I stay updated on PMC latest projects and initiatives?",
        answer:
            `You can stay updated by subscribing to our newsletter on our website or following us on our 
  social media channels. We regularly share news about our projects, investment opportunities, and
  industry insights`,
    },
    {
        id: 6,
        question: "How can I get started with PMC's consulting services?",
        answer:
            `You can contact us through our website, email, or phone to schedule a consultation and discuss how we can assist with your business needs.`,
    },
];
const FAQ = () => {
    const [activeId, setActiveId] = useState(null);
    const contentRefs = useRef([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const toggleFAQ = (id) => {
        setActiveId((prevId) => (prevId === id ? null : id));
    };
    useEffect(() => {
        // Update the height of the content when the activeId changes
        contentRefs.current.forEach((ref, index) => {
            if (ref) {
                const isActive = activeId === faqs[index].id;
                ref.style.height = isActive ? `${isMobile?"200":"84"}px` : "0px";
            }
        });
    }, [activeId, faqs]);
    return (
        <div
            className="elementor-element elementor-element-32a8400 e-con-full qodef-elementor-content-grid e-flex e-con e-parent e-lazyloaded"
            data-id="32a8400"
            data-element_type="container"
            
        >

            <div
                className="elementor-element elementor-element-ddf5008 elementor-widget elementor-widget-startpro_core_section_title"
                data-id="ddf5008"
                data-element_type="widget"
                data-widget_type="startpro_core_section_title.default"
            >
                <div className="elementor-widget-container">
                    <div className="qodef-shortcode qodef-m  qodef-section-title qodef-alignment--center">
                        <h2 className="qodef-m-title">Frenquently Asked Questions </h2>
                    </div>
                </div>
            </div>
            <div
                className="elementor-element elementor-element-2573eb7 elementor-widget elementor-widget-startpro_core_accordion"
                data-id="2573eb7"
                data-element_type="widget"
                data-widget_type="startpro_core_accordion.default"
            >
                <div className="elementor-widget-container">
                <div 
            className="qodef-shortcode qodef-m qodef-accordion clear qodef-behavior--accordion qodef-layout--simple ui-accordion ui-widget ui-helper-reset qodef--init"
            role="tablist"
        >
            {faqs.map(({ id, question, answer }, index) => (
                <React.Fragment key={id}>
                    <h5
                        className={`qodef-accordion-title ui-accordion-header ui-corner-top ui-state-default ${
                            activeId === id ? "ui-accordion-header-active ui-state-active" : ""
                        }`}
                        role="tab"
                        id={`ui-id-${id}`}
                        aria-controls={`ui-id-content-${id}`}
                        aria-selected={activeId === id}
                        aria-expanded={activeId === id}
                        tabIndex={0}
                        onClick={() => toggleFAQ(id)}
                    >
                        <span className="qodef-tab-title">{question}</span>
                        <span className="qodef-accordion-mark">
                            {activeId === id ? (
                                <span className="qodef-icon--minus">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={22} height={1}>
                                        <path fill="none" stroke="currentColor" d="M0 .5h22" />
                                    </svg>
                                </span>
                            ) : (
                                <span className="qodef-icon--plus">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22}>
                                        <g fill="none" stroke="currentColor">
                                            <path d="M0 11h22" />
                                            <path d="M11 0v22" />
                                        </g>
                                    </svg>
                                </span>
                            )}
                        </span>
                    </h5>
                    <div
                     ref={(el) => (contentRefs.current[index] = el)}
                        className="qodef-accordion-content ui-accordion-content ui-corner-bottom ui-helper-reset ui-widget-content"
                        id={`ui-id-content-${id}`}
                        aria-labelledby={`ui-id-${id}`}
                        role="tabpanel"
                        aria-hidden={activeId !== id}
                        style={{
                            overflow: "hidden",
                            transition: "height 0.4s ease-in-out",
                            height: activeId === id ? `${120}px` : "0px",
                        }}
                        // style={{
                        //     display: activeId === id ? "block" : "none",
                        //     height: activeId === id ? "auto" : "0px",
                        //     overflow: "hidden",
                        //     transition: "height 0.3s ease-in-out",
                        // }}
                    >
                        <div className="qodef-accordion-content-inner" style={{fontSize:"16px"}}>
                            <p>{answer}</p>
                        </div>
                    </div>
                </React.Fragment>
            ))}
        </div>
                </div>
            </div>
            <div
                className="elementor-element elementor-element-49979f9 e-con-full e-flex e-con e-child"
                data-id="49979f9"
                data-element_type="container"
            >
                <div
                    className="elementor-element elementor-element-4773b88 elementor-widget__width-auto elementor-widget elementor-widget-startpro_core_section_title"
                    data-id="4773b88"
                    data-element_type="widget"
                    data-widget_type="startpro_core_section_title.default"
                >
                    <div className="elementor-widget-container">
                        <div className="qodef-shortcode qodef-m  qodef-section-title qodef-alignment--left ">
                            <p className="qodef-m-title">
                                Still Searching for the Answer You Need?{" "}
                            </p>
                        </div>
                    </div>
                </div>
                <div
                    className="elementor-element elementor-element-6803e4b elementor-widget elementor-widget-startpro_core_button"
                    data-id="6803e4b"
                    data-element_type="widget"
                    data-widget_type="startpro_core_button.default"
                >
                    <div className="elementor-widget-container">
                        <a
                            className="qodef-shortcode qodef-m  qodef-button qodef-layout--textual  qodef-html--link "
                            href="/contact_us"
                            target="_self"
                        >
                            <span className="qodef-m-text">View Contact Us Page</span>
                        </a>
                    </div>
                </div>
                
            </div>
        </div>
    )
}

export default FAQ
